import React from 'react'
import {useTranslation} from 'react-i18next'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'

const Option = styled.span`
  &:hover {
    color: var(--bs-primary);
  }
`

const CitiesFilter = (props) => {
  const {machine, cities} = props
  const [current, send] = machine
  const {i18n} = useTranslation()

  const cityFilterd = current.context.filters.find((filter) => filter.param === 'city')
  const cityFilterValue = cityFilterd && cityFilterd.value

  const onCityFilter = (city) => {
    if (cityFilterValue === city.value) {
      send({ type: 'FILTER_REMOVE', param: 'city' })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: 'city',
          label: city.label,
          value: city.value
        }
      })
    }

    if (isMobile) {
      props.setIsOpen(!props.isOpen)
    }
  }

  return (
    <>
      {cities.map((city) => (
        <div key={city.value} className="mb-1">
          <input
            type="radio"
            className="me-2"
            checked={city.value === cityFilterValue}
            onChange={() => onCityFilter(city)}
            style={{ cursor: 'pointer' }}
          />
          <label
            onClick={() => onCityFilter(city)}
            style={{ cursor: 'pointer' }}
          >
            <Option className={city.value === cityFilterValue ? 'fw-semibold' : 'fw-normal'}>{city.label}</Option>
          </label>
        </div>
      ))}
    </>
  )
}

export default CitiesFilter
